export const environment = {
  production: true,
  version: 'METEC-IME-22.12.16.07'
};
